import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

interface RegrasInterface {
    idPerfil?: number,
    disabled?: boolean,
    setPerfilUsuario?: any
}

export default function SelRegras(props: RegrasInterface) {
    const [perfil, setPerfil] = React.useState(1);

    React.useEffect(() => {
        if(props?.idPerfil){
            setPerfil(props?.idPerfil);
        }
    }, [props.idPerfil]);

    const handleChange = (event: SelectChangeEvent<number>) => {
        props.setPerfilUsuario(event.target.value);
    };

    return (
        <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Perfil</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={perfil}
                    label="Perfil"
                    onChange={handleChange}
                    disabled={props.disabled}
                >
                    <MenuItem value={1}>ROOT</MenuItem>
                    <MenuItem value={2}>SUPORTEBRF</MenuItem>
                    <MenuItem value={3}>SUPORTECOPACKER</MenuItem>
                    <MenuItem value={4}>PLANEJAMENTOBRF</MenuItem>
                    <MenuItem value={5}>PLANEJAMENTOCOPAKER</MenuItem>
                    <MenuItem value={6}>MATERIAPRIMABRF</MenuItem>
                    <MenuItem value={7}>MATERIAPRIMACOPAKER</MenuItem>

                </Select>
            </FormControl>
        </Box>
    );
}